/* eslint-disable react-refresh/only-export-components -- False positive for use right now. No iimediate need to split. https://github.com/ArnaudBarre/eslint-plugin-react-refresh/issues/22*/
import React, { createContext, useContext, useEffect, useState } from 'react';
import { BackendApiContext } from './BackendApiContext';

export type TranslationContextType = {
    l: (key: string) => string;
    loading: boolean;
    error: string | undefined;
};

export interface TranslationsDto {
    texts: KeyValuePairDto[];
}

interface KeyValuePairDto {
    key: string;
    value: string;
}

export const Context = createContext<TranslationContextType>({
    l: (key: string) => key,
    loading: true,
    error: undefined
});

export const TranslationContextProvider = ({
    market,
    children
}: {
    market: string;
    children: React.ReactNode;
}) => {
    const [translations, setTranslations] = useState<TranslationsDto>();
    const [error, setError] = useState<string | undefined>(undefined);
    const [loading, setLoading] = useState(true);
    const { backendApi } = useContext(BackendApiContext);

    useEffect(() => {
        if (!market || !backendApi) {
            return;
        }
        backendApi
            .getTranslations(market)
            .then((translations) => setTranslations(translations))
            .catch((error) => {
                setError(
                    error instanceof Error ? error.message : String(error)
                );
            })
            .finally(() => {
                setLoading(false);
            });
    }, [market, backendApi]);

    const getTranslation = (key: string) => {
        if (!translations) {
            return '';
        }

        const translation = translations.texts.find(
            (text: { key: string }) => text.key === key
        );
        if (translation === undefined || translation === null) {
            return key;
        }
        if (translation?.value === undefined || translation?.value === null) {
            return key;
        }
        return translation?.value;
    };

    return (
        <Context.Provider
            value={{ l: getTranslation, loading: loading, error: error }}
        >
            {children}
        </Context.Provider>
    );
};

export default TranslationContextProvider;
